import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import Styled from 'styled';
import { LinearProgress } from '@rmwc/linear-progress';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import IconButtonView from 'four-nets/ui/icon-button/icon-button-view';
import refresh from 'four-nets/icons/svg/icon_refresh.svg';
import clear from 'four-nets/icons/svg/icon_delete_2.svg';

import defaultStyles from './images-preview-item.scss';

interface Props {
    thumbnail: React.ReactNode;
    progress: number;
    uploading: boolean;
    error?: React.ReactNode;
    onRemove: () => void;
    onRetry: () => void;
    styles: typeof defaultStyles;
}

@observer
class ImagesPreviewItem extends React.Component<Props> {
    render() {
        const { thumbnail, progress, uploading, error, onRemove, onRetry, styles } = this.props;

        return (
            <div className={styles.fileUploadList}>
                <div className={styles.thumbnail}>{thumbnail}</div>
                <div className={styles.upload}>
                    {uploading ? <LinearProgress color='red' progress={(progress - 10) / 100} /> : null}
                    {error ? (
                        <div className={styles.error}>
                            <p className={styles.errorText}>
                                <FormattedMessage id='LABEL_UPLOAD_FAILED' />
                            </p>
                            <IconButtonView onClick={onRetry}>
                                <SVGIcon style={{ image: styles.icon }} src={refresh} />
                            </IconButtonView>
                        </div>
                    ) : null}
                    <button className={styles.removeButton} onClick={onRemove}>
                        <SVGIcon style={{ image: styles.icon }} src={clear} />
                    </button>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(ImagesPreviewItem);
